import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-rc.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationDetailsRcConstants } from "./create-application-details-rc.constant";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
let CreateApplicationDetailsRcComponent = class CreateApplicationDetailsRcComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    searchApplicationsService;
    // Labels and headers
    descriptionLbl = CreateApplicationDetailsRcConstants.DESCRIPTION_LBL;
    applicationTypeLbl = CreateApplicationDetailsRcConstants.TYPE_LBL;
    reasonForApplicationLabel = CreateApplicationDetailsRcConstants.REASON_FOR_APPLICATION;
    typeOfTransferLabel = CreateApplicationDetailsRcConstants.TYPE_OF_TRANSFER_LABEL;
    propertyTypeLabel = CreateApplicationDetailsRcConstants.PROPERTY_TYPE_LABEL;
    ratesAccountNumberLabel = CreateApplicationDetailsRcConstants.RATES_ACCOUNT_NUMBER_LABEL;
    electronicReferenceLabel = CreateApplicationDetailsRcConstants.ELECTRONIC_REFERENCE_LABEL;
    attorneyReferenceLabel = CreateApplicationDetailsRcConstants.ATTORNEY_REFERENCE_LABEL;
    councilReferenceLabel = CreateApplicationDetailsRcConstants.COUNCIL_REFERENCE_LABEL;
    // Controls
    descriptionCtrl = CreateApplicationDetailsRcConstants.DESCRIPTION_CTRL;
    detailsFormGroupName = CreateApplicationDetailsRcConstants.DETAILS_FORM_GROUP_NAME;
    applicationTypeCtrl = CreateApplicationDetailsRcConstants.TYPE_CTRL;
    reasonForApplicationFormControlName = CreateApplicationDetailsRcConstants.REASON_FOR_APPLICATION_CONTROL_NAME;
    typeOfTransferFormControlName = CreateApplicationDetailsRcConstants.TYPE_OF_TRANSFER_CONTROL_NAME;
    propertyTypeFormControlName = CreateApplicationDetailsRcConstants.PROPERTY_TYPE_CONTROL_NAME;
    ratesAccountNumberFormControlName = CreateApplicationDetailsRcConstants.RATES_ACCOUNT_NUMBER_CONTROL_NAME;
    electronicReferenceFormControlName = CreateApplicationDetailsRcConstants.ELECTRONIC_REFERENCE_CONTROL_NAME;
    attorneyReferenceFormControlName = CreateApplicationDetailsRcConstants.ATTORNEY_REFERENCE_CONTROL_NAME;
    councilReferenceFormControlName = CreateApplicationDetailsRcConstants.COUNCIL_REFERENCE_CONTROL_NAME;
    validationMessages = CreateApplicationDetailsRcConstants.VALIDATION_MESSAGES;
    applicationTypePlaceHolder = CreateApplicationDetailsRcConstants.APPLICATION_PLACE_HOLDER;
    applicationTypes = [];
    typeOfTransferLookupOptions = [];
    detailsForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    selectedApplicationDetailsRcSubscription;
    getLookupsObservableSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        if (this.aflaModuleStrategyService.lookups.has("applicationTypes") && this.aflaModuleStrategyService.lookups.has("transferType")) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            this.typeOfTransferLookupOptions = this.aflaModuleStrategyService.lookups.get("transferType");
        }
        else {
            this.getLookups();
        }
        if (this.isApplicationLoadedFromTheSearchPage) {
            // application loaded from the search page.
            this.checkApplicationData();
        }
        this.setupSubscriptions();
        this.changeDetectorRefs.detectChanges();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationDetailsRcSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateApplicationDetailsData(application);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.detailsFormGroupName);
        this.detailsForm.enable();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID} and deleted eq false`
        };
        this.getLookupsObservableSubscription = this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsRcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const typeOfTransfer = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.toLowerCase() === "applicationtype") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.toLowerCase() === "transfertype") {
                    typeOfTransfer.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        typeOfTransfer.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.aflaModuleStrategyService.lookups.set("transferType", typeOfTransfer);
        this.applicationTypes = applicationTypes;
        this.typeOfTransferLookupOptions = typeOfTransfer;
        this.changeDetectorRefs.detectChanges();
    }
    loadMetadata() {
    }
    checkApplicationData() {
        const isFormPristine = this.detailsForm.pristine;
        const isFormUnTouched = this.detailsForm.untouched;
        const isFormInvalid = this.detailsForm.invalid;
        if (isFormPristine && isFormUnTouched && isFormInvalid) {
            this.populateApplicationDetailsData(this.selectedApplication);
        }
    }
    populateApplicationDetailsData(application) {
        this.detailsForm.get(this.applicationTypeCtrl).setValue(application.type);
        this.detailsForm.get(this.descriptionCtrl).setValue(application.description);
        this.detailsForm.get(this.reasonForApplicationFormControlName).setValue(application.reasonForApplication);
        this.detailsForm.get(this.typeOfTransferFormControlName).setValue(application.typeOfTransfer);
        this.detailsForm.get(this.propertyTypeFormControlName).setValue(application.propertyType);
        this.detailsForm.get(this.ratesAccountNumberFormControlName).setValue(application.ratesAccountNumber);
        this.detailsForm.get(this.electronicReferenceFormControlName).setValue(application.electronicReference);
        this.detailsForm.get(this.attorneyReferenceFormControlName).setValue(application.attorneyReference);
        this.detailsForm.get(this.councilReferenceFormControlName).setValue(application.councilReference);
    }
    setupSubscriptions() {
        this.subscribeToSelectedApplication();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsRcComponent = __decorate([
    Component({
        selector: "app-create-application-details-rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsRcComponent);
export { CreateApplicationDetailsRcComponent };
